class TaskCategoryPermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'task_category.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'task_category._m';

    // Can access disabled task categories
    static ACCESS_DISABLED = 'task_category.access.disabled';

    // Can access archived task categories
    static ACCESS_ARCHIVE = 'task_category.access.archive';

    // Can create task categories
    static CREATE = 'task_category.create';

    // Update task category info
    static UPDATE = 'task_category.update';

    // Manage groups, attached to category
    static GROUP_MANAGE = 'task_category.group.manage';

    // Manage complexity settings
    static COMPLEXITY_MANAGE = 'task_category.complexity_manage';

    // Archive task category
    static ARCHIVE = 'task_category.archive';

    // Restore archived task category
    static RESTORE = 'task_category.restore';
}

export default TaskCategoryPermission;
